vue
<template>
    <div class="container">
        <div class="content">
            <h1>List Product <span>Upload your designed styles and share them to let more people see</span></h1>

            <div class="panel main-panel">
                <h2 class="title">Basic Information</h2>
                <div class="wrap">
                    <div class="form-group">
                        <div class="form-label">Product Name<span>*</span></div>
                        <div class="form-control">
                            <input type="text" class="input" placeholder="Please enter product name" v-model="form_data.name"/>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-label">Product Image<span>*</span></div>
                        <div class="form-control">
                            <div class="main-image">
                                <Upload :action="upload_url"
                                        :data="{dir:'template'}"
                                        :show-upload-list="false"
                                        :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'image')"
                                >
                                    <div class="main-image">
                                        <template v-if="form_data.image">
                                            <img :src="form_data.image" alt="" style="width:100%;height:100%">
                                        </template>
                                        <template v-else>
                                            <img src="../../../assets/images/icon-add-3.png" alt=""
                                                 class="icon-upload">
                                            <p>Click or drag product design image to upload here</p>
                                        </template>

                                    </div>
                                </Upload>
                            </div>
                        </div>
                    </div>

                    <div class="form-group ">
                        <div class="form-label">Product Category<span>*</span></div>
                        <div class="form-control">
                            <select v-model="form_data.product_category_id">
                                <option value="0">Please select</option>
                                <option v-for="(v,k) in product_category_list" :key="`dpc`+k"
                                        :value="v.product_category_id">{{v.category_name_cn}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group ">
                        <div class="form-label">Applicable Gender</div>
                        <div class="form-control">
                            <select v-model="form_data.sex">
                                <option value="0">Unisex</option>
                                <option value="1">Men's</option>
                                <option value="2">Women's</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-label">Product Description</div>
                        <div class="form-control">
                            <textarea placeholder="Please enter your product description" v-model="form_data.description"></textarea>
                        </div>
                    </div>

                </div>
            </div>

            <div class="panel param-panel">
                <h2 class="title">Parameter Information</h2>
                <div class="param-list">
                    <div class="param-item" v-for="(v,k) in form_data.param" :key="`p`+k">
                        <div><input type="text" class="key" v-model="v.key" :readonly="k<2" placeholder="Enter name"></div>
                        <div><input type="text" class="value" v-model="v.value" :readonly="k<2"></div>
                        <img src="../../../assets/images/close@2x.png" class="btn-close" alt="" v-show="k>1" @click="delete_param(k)">
                    </div>
                </div>
                <div class="btn-param" @click="add_param">+ Add Parameter</div>
            </div>

            <div class="panel detail-panel">
                <h2 class="title">Detailed Description</h2>
                <editor v-model="form_data.detail" :is-clear="true" @change="change_richtext" />
            </div>


            <div class="footer">
                <div class="btn btn-confirm" @click="save">List in Shop</div>
                <div class="btn btn-confirm" @click="asyncShop">One-click Distribution</div>
            </div>
        </div>

        <popup :show.sync="is_popup_show" width="500px" height="250px" @on-close="close">
            <h2>Select Shop</h2>
            <div class="form">
                
                <div class="form-group w50">
                    <div class="form-label">Shop:</div>
                    <div class="form-control">
                        <select v-model="shop_id">
                           
                            <option
                                v-for="(v, k) in shop_list"
                                :key="`dpc1` + k"
                                :value="v.id"
                            >
                                {{ v.shop_name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="btn-submit" @click="getShopInfo">Confirm</div>
            </div>
        </popup>
        <popup :show.sync="is_popup_kuai_show" width="500px" height="420px" @on-close="close">
            <h2>Product Information</h2>
            <div class="form">
            
                <div class="form-group">
                    <div class="form-label">Category:</div>
                    <div class="form-control">
                        <Cascader class="input1" filterable :data="kuaiCategory" v-model="categoryValue"  placeholder="Please select category"></Cascader>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">Shipping Template:</div>
                    <div class="form-control">
                        <select v-model="kuaiForm.expressTemplateId">
                            <option
                                v-for="(v, k) in shop_info.template"
                                :key="`dpc1` + k"
                                :value="v.id"
                            >
                                {{ v.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">Refund Policy:</div>
                    <div class="form-control">
                        <select v-model="kuaiForm.refundRule">
                            <option
                                v-for="(v, k) in shop_info.refundRuleList"
                                :key="`dpc1` + k"
                                :value="v.value"
                            >
                                {{ v.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">Service Commitments:</div>
                    <div class="form-control">
                        <label style="mrgin-right:10px;" v-for="(v, k) in shop_info.servicePromise" :key="`dpc1` + k">
                            <input type="checkbox" v-model="v.value" />{{ v.name }}
                        </label>
                    </div>
                </div>
                
                
                <div class="btn-submit" @click="submit()">Submit</div>
            </div>
        </popup>
    </div>
</template>

<script>
    import Popup from "@/components/Popup.vue";
    import Editor from '@/components/WangEditor'
    import {
        SaveProduct,
        GetDesign,
        GetProduct,
        Profile,
        ProductCategoryList
    } from "@/api/index.js";
    import { 
        GetMyShopList,
        AddProduct,
        GetShopInfo,
    } from '@/api/open'
    import kuaiCategory from "@/utils/kuaiCategory.js"
    import axios from "axios";

    const form_data = {
        id: 0,
        name: "",
        image: "",
        status: 0,
        sex: 0,
        product_category_id: 0,
        description: "",
        param: [
            {key: 'Style No.', value: ''},
            {key: 'Fit', value: ''},
        ],
        detail: "",
        uuid: ""
    };

    export default {
        name: "ProductEdit",
        components: {
            Editor,
            Popup
        },
        data() {
            return {
                design_uuid: '',
                uuid: '',
                upload_url: process.uniEnv.BASE_API + '/util/upload-image',
                form_data: {...form_data},
                design_list: [],
                product_category_list: [],
                shop_list:[],
                is_popup_show:false,
                shop_id:0,
                shop_info:{},
                kuaiCategory,
                categoryValue:[],
                kuaiForm:{
                    refundRule:'',
                    servicePromise:'',
                    categoryId:'',
                    expressTemplateId:''
                },
                is_popup_kuai_show:false
            };
        },
        watch: {
            // 监听路由参数的变化
            "$route.query.uuid": {
                handler(newVal, oldVal) {
                    console.log(newVal, oldVal);
                    if (newVal !== oldVal) {
                        // 更新数据
                        this.uuid = newVal;
                        this.getProduct()
                    }
                },
                immediate: true, // 立即执行一次handler以初始化数据
                deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
            },
           
        },

        computed: {},
        methods: {
            change_richtext(e) {
                this.form_data.detail = e
            },
            add_param() {
                this.form_data.param.push({key: '', value: ''})
            },
            delete_param(k) {
                this.form_data.param.splice(k, 1)
            },
            save() {
                SaveProduct({...this.form_data, uuid: this.uuid, design_uuid: this.design_uuid}).then((response) => {
                    this.$layer.msg(`Listed successfully`);
                    this.$router.go(-1);
                    // this.$router.replace({
                    //     name: "ProductEdit",
                    //     query: {uuid: response.data.uuid},
                    // });
                }).catch((res) => {
                    this.$layer.msg(res.msg);
                });
            },
            handleSuccess(response, file, fileList, field) {
                this.$set(this.form_data, field, response.data.url);
            },
            async getProductCategoryList() {
                return ProductCategoryList().then((response) => {
                    this.product_category_list = [...response.data];
                    return response;
                });
            },
            async getProfile() {
                return Profile().then((response) => {
                    return response;
                });
            },
            async getProduct() {
                this.$Spin.show();
                GetProduct({
                    uuid: this.uuid,
                }).then((response) => {
                    this.form_data = response.data
                }).finally(() => {
                    this.$Spin.hide();
                });
            },
            async getOpenShop() {
                GetMyShopList().then((response)=>{
                    this.shop_list = response.data.filter((i)=>{
                        return i.is_auth == 1
                    })
                })
            },
           
            asyncShop() {
                this.is_popup_show = true
            },
            close() {
                this.is_popup_show = false
            },
            submit(){
               
                if(this.categoryValue.length == 0) {
                    return  this.$layer.msg('Please select category')
                }
                if(!this.kuaiForm.expressTemplateId) {
                     return  this.$layer.msg('Please select shipping template')
                }
                if(!this.kuaiForm.refundRule) {
                     return  this.$layer.msg('Please select refund policy')
                }
              
                const servicePromise = this.shop_info.servicePromise.reduce((acc, item) => {
                    acc[item.code] = item.value;
                    return acc;
                }, {});
                let param = {
                    refundRule: this.kuaiForm.refundRule,
                    expressTemplateId: this.kuaiForm.expressTemplateId,
                    servicePromise,
                    categoryId:this.categoryValue[this.categoryValue.length - 1],
                    shop_id: this.shop_id,
                    uuid:this.uuid
                }
              
                AddProduct(param).then((response) => {
                    this.getProduct();
                }).catch(res => {
                    this.$layer.msg(res.msg)
                }).finally(() => {
                    this.is_popup_kuai_show = true
                })
            },
            async getShopInfo() {
                let { data } = await GetShopInfo({
                    shop_id: this.shop_id
                })
                this.shop_info = data
                this.is_popup_show = false
                this.is_popup_kuai_show = true
            }
            
        },
        mounted() {
            if (this.$route.query.design_uuid) {
                this.design_uuid = this.$route.query.design_uuid;
                this.$Spin.show();
                GetDesign({
                    uuid: this.design_uuid,
                }).then((response) => {
                    this.form_data.name = response.data.name;
                    this.form_data.image = response.data.image;
                    this.form_data.sex = response.data.sex;
                    this.form_data.description = response.data.description;
                    this.form_data.product_category_id = response.data.product_category_id;
                    this.form_data.param[0].value = response.data.style_no;
                }).finally(() => {
                    this.$Spin.hide();
                });
            }
            axios.all([
                this.getProfile(),
                this.getProductCategoryList(),
                this.getOpenShop()
            ])
            
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // 通过 `vm` 访问组件实例
                vm.$emit("showFooter", false);
            });
        },
        beforeRouteLeave(to, from, next) {
            this.$emit("showFooter", true);
            next();
        },
    };
</script>

<style lang="scss" scoped>
    .container {
        background: #f6f7fa;
        padding: 10px 0 150px 0;
        display: flex;
        justify-content: center;

        .content {
            width: 1060px;
            h1 {
                padding: 20px 0;
                color: #333333;
                font-weight: bold;
                font-size: 20px;

                span {
                    font-size: 14px;
                    color: #6e6e6e;
                    font-weight: normal;
                    margin-left: 10px;
                }
            }
        }

        .panel {
            margin: 10px 0;
            padding:20px 30px;
            background: white;
            border-radius: 5px;
            .title {
                height: 20px;
                line-height: 20px;
                font-size: 16px;
                border-left: 3px solid #fa3d5a;
                padding-left: 8px;
                margin-bottom: 25px;

                span {
                    font-size: 16px;
                    color: #fa3d5a;
                }
            }
        }



        .main-panel {
            .wrap {
                .main-image {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    align-content: center;
                    background: #fafafa;
                    width: 230px;
                    height: 230px;
                    border-radius: 5px;

                    .icon-upload {
                        width: 52px;
                        height: 60px;
                    }

                    p {
                        width: 100%;
                        color: #4d4f52;
                        font-size: 14px;
                        margin-top: 26px;
                        text-align: center;
                    }
                }

                .form-group {
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;
                    .form-label {
                        width: 80px;
                        font-size: 14px;
                        color: #666666;
                        font-weight: bold;
                        span {
                            font-size: 14px;
                            color: #fa3d5a;
                            font-weight: normal;
                        }
                    }

                    .form-control {
                        position: relative;

                        input {
                            width: 800px;
                            height: 43px;
                            padding: 0 15px;
                            border: 1px solid #e2e5e9;
                            font-size: 14px;
                        }
                        select {
                            width: 550px;
                            height: 43px;
                            line-height: 43px;
                            padding: 0 15px;
                            border: 1px solid #e2e5e9;
                            font-size: 14px;
                        }

                        textarea {
                            width: 550px;
                            height: 105px;
                            padding: 15px;
                        }
                    }

                }
            }

        }

        .param-panel {
            .param-list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .param-item {
                    display: flex;
                    width: 485px;
                    height: 43px;
                    margin: 10px 0;
                    position: relative;
                    .key {
                        width: 100px;
                        height: 43px;
                        line-height: 43px;
                        background: #F5F5F5;
                        border: 1px solid #E2E5E9;
                        text-align: center;
                        color: #666666;
                        outline: none;
                        font-size: 14px;
                        font-weight: bold;
                    }
                    .value {
                        width: 385px;
                        height: 43px;
                        line-height: 43px;
                        font-size: 14px;
                        padding: 0 16px;
                        box-sizing: border-box;
                        outline: none;
                        border: 1px solid #E2E5E9;
                    }
                    .btn-close {
                        position: absolute;
                        top: 15px;
                        right: 15px;
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                    }
                }
            }

            .btn-param {
                width: 151px;
                height: 43px;
                line-height: 43px;
                background: #F5F5F5;
                border-radius: 5px 5px 5px 5px;
                border: 1px solid #E2E5E9;
                color: #666666;
                text-align: center;
                margin-top: 30px;
                cursor: pointer;
            }
        }

        .footer {
            position: fixed;
            height: 110px;
            line-height: 110px;
            left: 0;
            right: 0;
            bottom: 0;
            background: white;
            text-align: center;
            z-index: 10001;

            .btn {
                display: inline-block;
                width: 140px;
                height: 38px;
                margin: 0 5px;
                line-height: 38px;
                text-align: center;
                font-size: 14px;
                border-radius: 20px;
                cursor: pointer;

                &.btn-confirm {
                    background: #fa3d5a;
                    color: white;
                }
            }
        }
        .flex-row{
            display: flex;
            padding: 0 20px;
        }
        
        ::v-deep .popup-modal {
			h2 {
				padding: 10px 20px;
				color: #333333;
				font-size: 18px;
				font-weight: bold;
				border-bottom: 1px solid #F0F0F0;
			}
			.form {
				padding: 10px 0;
				.form-group {
					display: flex;
					flex-wrap: wrap;
					justify-content: left;
					align-items: center;
					margin-top: 20px;
					.form-label {
						width: 100px;
						font-size: 14px;
						color: #696A6A;
						text-align: right;
					}
					.form-control {
						position: relative;
						.input,select {
							width: 300px;
							height: 48px;
							line-height: 48px;
							border: 1px solid #D9D9D9;
							border-radius: 5px;
							padding: 0 10px;
							outline: none;
							font-size: 14px;
							&[readonly] {
								border: none;
							}
						}

					}
				}

				.btn-submit {
					margin: 40px auto;
					width: 200px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 6px;
					cursor: pointer;
				}

			}
		}
        
    }
    ::v-deep .ivu-input {
		width: 300px;
		height: 48px;
		line-height: 48px;
		border: 1px solid #E3E3E3;
		border-radius: 10px;
		padding: 0 10px;
		outline: none;
	}
    ::v-deep .ivu-cascader-label {
        line-height: 48px;
    }

</style>
